/**
 * Max practical CSS z-index (signed 32-bit). Used for layers that must sit above
 * typical third-party overlays (product tours, chat widgets, etc.).
 */
export const Z_INDEX_MAX_32 = '2147483647' as const;

/** Tailwind `theme.extend.zIndex` entries for the design system. */
export const tailwindZIndexExtend = {
  toast: Z_INDEX_MAX_32,
} as const;
